
import ReceiptDisscount from "../../../assets/filled/ReceiptDisscount.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiptDisscountIcon({ className, dataTestid = "ReceiptDisscountIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiptDisscount data-testid={dataTestid} className={classes} {...rest} />
  );
}
